import { BrandsAPI } from '../../../../constructs/brands/interface';
import { useAPIContext } from '../../context/api';

export const useValidateMedia = () => {
  const { callEndpoint } = useAPIContext();

  const validateMediaUrl = async (url: string) => {
    if (!url) return { ok: true };

    const res = await callEndpoint<BrandsAPI, 'validate-media'>('brands', '/media/validate', 'POST', {
      urls: [url]
    });

    return res; // { ok, checkedUrls, invalidUrls }
  };

  return { validateMediaUrl };
};
